import * as React from "react";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import { sentry } from "@talentpair/sentry";
import { userService, apiRequest } from "@talentpair/api";
import { MailToLink, Typography, Box, Button } from "@talentpair/quantic";
import { MessageT } from "../../../types";

type SessionFeedbackProps = {
  sessionid: string;
  messages: MessageT[];
};

export function SessionFeedback({ sessionid, messages }: SessionFeedbackProps): React.ReactElement {
  const [voted, setVoted] = React.useState(false);

  const feedbackBody =
    voted && (userService.isQaUser() || userService.isRecruiter()) && messages.length
      ? `\n\n\nSession data:\n${JSON.stringify(
          messages
            // @ts-expect-error - it's fine
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .map(({ data = null, ...msg }) => msg)
            .reverse()
            .slice(0, 6)
            .reverse(),
          undefined,
          2,
        )}${messages.length > 6 ? "\n..." : ""}`
      : undefined;

  return voted ? (
    <Typography
      variant="body2"
      color="grey.700"
      align="center"
      style={{ paddingTop: 6, paddingBottom: 6 }}
    >
      Thanks.{" "}
      <MailToLink
        target="_bank"
        color="grey-700"
        email="feedback@talentpair.com"
        subject={`Feedback on Talentpair Assistant${sessionid ? ` - Chat #${sessionid}` : ""}`}
        body={feedbackBody}
        className="underline"
      >
        Additional feedback?
      </MailToLink>
    </Typography>
  ) : (
    <>
      <Typography variant="body2" color="grey.700" align="center">
        Rate this chat:
      </Typography>
      <Box variant="row" layout="center-start">
        <Button
          variant="icon"
          icon={ThumbUpOutlinedIcon}
          size="md"
          color="grey.500"
          data-testid="upvote-button"
          onClick={() => {
            apiRequest
              .post(`teleprompter/chat/feedback/`, { sessionid, score: 1 })
              .catch((err) => (err ? sentry.error(err) : undefined));
            setVoted(true);
          }}
        />
        <Button
          variant="icon"
          icon={ThumbDownOutlinedIcon}
          size="md"
          color="grey.500"
          data-testid="downvote-button"
          onClick={() => {
            apiRequest
              .post(`teleprompter/chat/feedback/`, { sessionid, score: 0 })
              .catch((err) => (err ? sentry.error(err) : undefined));
            setVoted(true);
          }}
        />
      </Box>
    </>
  );
}
